import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";
import { GOLD } from "@/lib/brand";

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", restaurant_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account creato!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore di registrazione");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "mt-1 w-full rounded-xl border border-white/15 bg-white/5 text-[#F5F1E6] px-4 py-3 placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-[#B2A475]/40 focus:border-[#B2A475] transition";

  return (
    <div className="min-h-screen bg-[#0B0B0C] flex items-center justify-center px-4 py-10 relative overflow-hidden" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full blur-3xl opacity-20" style={{ background: GOLD }} />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full blur-3xl opacity-10" style={{ background: GOLD }} />
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="flex items-center justify-center gap-3 mb-8">
          <BrandLogo className="w-12 h-12" />
          <span className="text-[#F5F1E6] text-2xl tracking-wide" style={{ fontFamily: "'Cormorant Garamond', serif" }}>The Cube Design</span>
        </Link>
        <div className="rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-xl p-8 shadow-2xl">
          <h1 className="text-3xl gold-text" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Crea il tuo menù</h1>
          <p className="text-white/50 text-sm mt-1">Registra il tuo ristorante o bar.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium text-white/70">Il tuo nome</label>
              <input required value={form.name} onChange={set("name")} data-testid="register-name" className={inputCls} />
            </div>
            <div>
              <label className="text-sm font-medium text-white/70">Nome del locale</label>
              <input required value={form.restaurant_name} onChange={set("restaurant_name")} data-testid="register-restaurant" className={inputCls} />
            </div>
            <div>
              <label className="text-sm font-medium text-white/70">Email</label>
              <input type="email" required value={form.email} onChange={set("email")} data-testid="register-email" className={inputCls} />
            </div>
            <div>
              <label className="text-sm font-medium text-white/70">Password</label>
              <input type="password" required value={form.password} onChange={set("password")} data-testid="register-password" className={inputCls} />
            </div>
            <button type="submit" disabled={loading} data-testid="register-submit" className="w-full rounded-full font-semibold py-3 transition-transform hover:scale-[1.01] flex items-center justify-center gap-2" style={{ background: GOLD, color: "#0B0B0C" }}>
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Crea account
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-white/50">
            Hai già un account? <Link to="/login" className="font-semibold gold-text" data-testid="go-login">Accedi</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
